import './style.css'

const Gradient = () => {

  return (
    <div className='banner__gradient'></div>
  );

}

export default Gradient;